import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import Formulaire from "../../components/Formulaire";
import Table from "../../components/Table";
import Layout from "../../layout/Layout";
import {
  createTypePiece,
  getTypePiece,
  updateTypePiece,
  deleteTypePiece,
} from "../../services/typePiece";
import ReactPaginate from "react-paginate";
import Loading from "../../components/Loading";

const TypePieces = () => {
  const headTable = [
    { name: "Libellé", width: "100%" },
    { name: "", width: "5%" },
  ];
  const [current, setCurrent] = useState(null);
  const forms = [
    {
      label: "Libellé (*)",
      type: "text",
      name: "libelle",
      values: current?.LIBELLE ?? "",
    },
  ];

  const [flash, setFlash] = useState({ message: null, color: "success" });

  // pagination code
  let PageSize = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [totalPage, setTotalPage] = useState(null);
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };

  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), tableData);
    setCurrentTableData(d);
    // console.log(d);
  };
  // fin code pagination

  const { mutate } = useMutation(createTypePiece, {
    onSuccess: ({ message }) => {
      setFlash({ message, color: "success" });
      setIsLoading(true);
      getTypePiece()
        .then((res) => {
          const { data, message } = res;
          const d = page(1, data);
          setCurrentTableData(d);
          const coutPage = parseInt(data.length / PageSize);
          setTotalPage(coutPage);
          setTableData(data);
          setIsLoading(false);
        })
        .catch(({ response }) => { });
    },
    onSettled: ({ data: { message } }) => {
      setFlash({ color: "success", message });
    },
    onError: ({ response }) => {
      setIsLoading(true);
      getTypePiece()
        .then((res) => {
          const { data, message } = res;
          // setFlash({ color: "success", message });
          const d = page(1, data);
          setCurrentTableData(d);
          const coutPage = parseInt(data.length / PageSize);
          setTotalPage(coutPage);
          setTableData(data);
          setIsLoading(false);
          // console.log(data);
        })
        .catch();
      setFlash({ color: "danger", message: response.data.message });
    },
  });

  const { mutate: updateMutate } = useMutation(updateTypePiece, {
    onSuccess: ({ message }) => {
      // Invalidate and refetch
      setFlash({ color: "success", message });
      setIsLoading(true);
      getTypePiece()
        .then((res) => {
          const { data, message } = res;
          // setFlash({ color: "success", message });
          const d = page(1, data);
          setCurrentTableData(d);
          const coutPage = parseInt(data.length / PageSize);
          setTotalPage(coutPage);
          setTableData(data);
          setIsLoading(false);
          // console.log(data);
        })
        .catch();
      // queryClient.invalidateQueries("typepieces");
    },
  });

  const postTypePiece = (data) => {
    if (data.libelle.length === 0) {
      setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
      setIsLoading(false);
      return false;
    }
    mutate(data)
  };
  const putTypePiece = (data) => {
    if (data.libelle.length === 0 || data.id.length === 0) {
      setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
      setIsLoading(false);
      return false;
    }
    updateMutate(data);
  }
  const onclick = (data) => {
    setCurrent(data);
  };
  // delete

  const onDelete = async () => {
    if (window.confirm("Etes vous sur de vouloir supprimer?")) {
      const data = { id: current.ID, nom: current.NOM };
      deleteTypePiece(data)
        .then(({ data }) => {
          console.log();
          setIsLoading(true);
          setCurrent(null);
          setFlash({ ...flash, message: data.message });
          getTypePiece()
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setTableData(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              setTotalPage(coutPage);
              // setFlash({ ...flash, message: message });

              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          // console.log(error.response);
          setIsLoading(true);
          setCurrent(null);
          setFlash({
            ...flash,
            color: "danger",
            message: error.response.data.message,
          });
          getTypePiece()
            .then((res) => {
              const { data, message } = res;
              const d = page(1, data);
              setTableData(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              setTotalPage(coutPage);
              // setFlash({ ...flash, message: message });

              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        });
    }
  };
  // delete

  useEffect(() => {
    setIsLoading(true);
    getTypePiece()
      .then((res) => {
        const { data, message } = res;
        const d = page(1, data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.length / PageSize);
        setTotalPage(coutPage);
        setTableData(data);
        setFlash({ message, color: "success" });
        setIsLoading(false);
      })
      .catch(({ response }) => { });
  }, []);
  return (
    <Layout>
      <Formulaire
        forms={forms}
        title={"Gestion des types de pièces d’identité"}
        cb={current ? putTypePiece : postTypePiece}
        current={current}
        setCurrent={setCurrent}
        color={flash?.color}
        isLoading={isLoading}
        message={flash?.message}
        onDelete={onDelete}
      />
      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <Table
          headTable={headTable}
          title={"Liste des types de pièces d’identité"}
        >
          {currentTableData?.map((item, key) => (
            <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
              <td>{item?.LIBELLE}</td>
              <td className="text-center" align="right">
                <img
                  onClick={() => onclick(item)}
                  style={{ width: 15, height: 10 }}
                  src={"/Catef_files/modifier.png"}
                />
              </td>
            </tr>
          ))}
          <tr
            className="pagination-od"
            align="center"
            style={{
              color: "Black",
              backgroundColor: "#EFF3F8",
              fontWeight: "normal",
              whiteSpace: "nowrap",
            }}
          >
            <td colSpan={5}>
              {totalPage != null && (
                <ReactPaginate
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  breakLabel="..."
                  nextLabel="suivant >"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  pageCount={totalPage + 1}
                  previousLabel="< précédent"
                  renderOnZeroPageCount={null}
                />
              )}
            </td>
          </tr>
        </Table>
      )}
    </Layout>
  );
};

export default TypePieces;
